import { Space, Tooltip, Typography } from "antd"
import DoughnutChart from "../Charts/DoughnutChart"
import VSpace from "../common/VSpace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons"
import { useSalesLeads } from "./dashboardQueries"
import { GraphingData } from "./dashboardApi"
import dayjs from "dayjs"
import ExportCsvButton from "../Datacenter/ExportCsvButton"
import useDashboardReporting from "../../hooks/useDashboardReporting"
import { chartExportColumns, chartExportRows } from "./dashboardExport"

export type Props = {
  start: string
  end: string
  // The end sent to the API, when it differs from the date shown.
  queryEnd?: string
  filtersApplied?: boolean
}

const SalesLeadsGraph = ({start, end, queryEnd = end, filtersApplied = false}: Props) => {
  const query = useSalesLeads(start, queryEnd)
  const dashboardReporting = useDashboardReporting()
  const hasDate = !!start && !!end

  const createDataset = (data: GraphingData | undefined) => {
    if(!data){
      return []
    }

    const dataset: any = []
    data.labels.forEach(function (value, i) {
      dataset.push({type: value,value:data.datasets[0][i]})
    });

    return dataset
  }

  return <div style={{ width: '440px'}}>
    <VSpace style={{minWidth: '440px', textAlign: 'center'}}>
      <Space>
        <h1 style={{font: '1.4em "Proza Libre'}}>Sales Leads</h1>
        <Tooltip title="By Category">
          <FontAwesomeIcon icon={faCircleInfo} />
        </Tooltip>
      </Space>
      { hasDate 
        ? <div>From {start} to {end}</div>
        : <div>Please select a time range at the top of the page.</div>
      }
      {dashboardReporting && hasDate && <div><ExportCsvButton size="small" reportName='Sales Leads' dateRange={{ start: dayjs(start), end: dayjs(end) }} columns={chartExportColumns('Leads')} rows={chartExportRows(query.data)} /></div>}
      {/* Sales leads come from the free-text customer Sales Lead field, which has no division, sales person or crew foreman. */}
      {filtersApplied && <Typography.Text type="secondary">Not affected by the division, sales person or crew foreman filters</Typography.Text>}
      <div style={{fontSize: '20pt', marginTop: '10px'}}></div>
      { query.isLoading 
        ? <span>Loading...</span> 
        : query.isError
          ? <span>Error loading data</span>
          : <DoughnutChart data={createDataset(query.data ?? undefined)} />
      }
    </VSpace>
  </div>
}

export default SalesLeadsGraph